// Samoan translations
export const sm: Record<string, string> = {
  'menu.dashboard': 'Laupapa Pulea',
  'menu.customers': 'Tagata Faʻatau',
  'menu.products': 'Oloa',
  'menu.users': 'Tagata Faʻaoga',
  'menu.settings': 'Faʻatulagaga',
  'menu.logout': 'Alu Ese',
  'dashboard.title': 'Laupapa Pulea',
  'dashboard.newOrder': 'Faʻatonuga Fou',
  'order.title': 'Faʻatonuga Fou',
  'order.customer': 'Tagata Faʻatau',
  'order.products': 'Oloa',
  'order.total': 'Aofaʻi',
  'users.title': 'Tagata Faʻaoga',
  'users.name': 'Igoa',
  'users.email': 'Meli Initaneti',
  'common.yes': 'Ioe',
  'common.no': 'Leai',
  'common.cancel': 'Soloia',
  'common.save': 'Teuina',
  'common.search': 'Sailiga',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Ulufale',
  'login.welcome': 'Talofa, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Meli Initaneti',
  'signup.phone': 'Telefoni',
  'menu.reportsAndAccounting': 'Lipoti ma Tusitusiga Tupe',
  'menu.systemAndCommunication': 'Faiga ma Fesootaiga',
};